import { Component, OnInit, Inject, ViewChild, ElementRef } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DialogBase } from 't4core';
import { ActiveRentalService } from 'app-components';
import { FormControl, Validators } from '@angular/forms';

@Component({
  selector: 'app-swap-confirmation',
  templateUrl: './swap-confirmation.html',
  styleUrls: ['./swap-confirmation.css'],
  standalone: false
})
export class SwapConfirmationDialog extends DialogBase implements OnInit {


  public noComment: boolean = false;
  public comment: string = "";


  readonly reason = new FormControl<string>('', {
    nonNullable: true,
    validators: [Validators.required, Validators.minLength(5)],
  });

  constructor(
    public activeRentalService: ActiveRentalService,
    public dialogRef: MatDialogRef<SwapConfirmationDialog>,
    @Inject(MAT_DIALOG_DATA) public data) {
    super("SwapConfirmationDialog");

    if (data?.comment)
      this.comment = data.comment;

  }


  async ngOnInit() {
    console.log(this.data);

  }


  public confirm() {
    if (this.reason.invalid) return;
    const comment = this.reason.value.trim();
    this.activeRentalService.updateReasonForSwap(comment)

    this.dialogRef.close(true);
  }

  public closeDialog() {
    this.dialogRef.close(false);
  }
}
